import { MerchantsRepository } from '../repositories/merchants.repository'
import { CreateMerchantPayloadT, GetMerchantParams, GetMerchantsListResponseT } from '../types/merchants.types'

const merchantsRepository = new MerchantsRepository()

export class MerchantsService {
    async getMerchantsList(params: GetMerchantParams): Promise<GetMerchantsListResponseT> {
        const response = await merchantsRepository.getMerchantsList(params)
        return response.data
    }

    async createMerchant(payload: CreateMerchantPayloadT): Promise<void> {
        const response = await merchantsRepository.createMerchant(payload)
        return response.data
    }

    async updateMerchant(merchant_id: number, payload: CreateMerchantPayloadT): Promise<void> {
        const response = await merchantsRepository.updateMerchant(merchant_id, payload)
        return response.data
    }

    async deleteMerchant(merchant_id: number): Promise<void> {
        const response = await merchantsRepository.deleteMerchant(merchant_id)
        return response.data
    }
}
